import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import WarehouseLayout from "../WarehouseLayout"
import WarehouseCategoriesTable from "./WarehouseCategoriesTable"
import { Autocomplete, TextField } from "@mui/material";
import PublicCatalogLayout from "../../layouts/PublicCatalogLayout"
const WarehouseCategoriesDashboard = (props) => {
  const { renters } = props;
  const [ selectedRenterId, setSelectedRenterId ] = useState({
    value: null,
    label: "Jaguar Design Studio",
    id: null
  });

  const getOptions = () => {
    return renters.map(x=> {
      return {
        label: x.name||"",
        value: x.id,
        id: x.id
      }
    }).concat([
      { label: "Jaguar Design Studio", value: null }
    ]).sort((a, b) => a.label.localeCompare(b.label))
  }

  return (
      <PublicCatalogLayout
        {...props}
        classNames={{body: 'white-background'}}
        breadcrumbs={
          [{name: "Inventory", url: "/"},{name: "Manage Inventory", url: "/management/items"}, {
            name: "Categories", url: "/management/categories"}]
        }
      >
        <div className="row">
          <div className="col-xs-12">
            <h1 className="catalog-h1"> Categories </h1>
            <Autocomplete
              sx={{
                background: "white",
              }}
              disableClearable
              options={getOptions()}
              value={selectedRenterId}
              onChange={(event, newValue) => {
                setSelectedRenterId(newValue);
              }}
              renderInput={(params) => <TextField {...params} label="Inventory" />}
            />
            <br/>
            <WarehouseCategoriesTable key={`warehouse-categories-table-${selectedRenterId.value}`} {...props} renter={selectedRenterId}/>
          </div>
        </div>
    </PublicCatalogLayout>
  );
}

export default WarehouseCategoriesDashboard;
